import React from 'react';
import { MdCheckCircle } from 'react-icons/md';
import styles from './ExpirationDateTag.module.scss';

type ExpirationDateTagProps = {
  expirationDate: string;
};

const ExpirationDateTag = ({ expirationDate }: ExpirationDateTagProps) => {
  const parseExpirationDate = (expirationDate: string): string => {
    return expirationDate;
  };

  return (
    <span className={styles['tag']}>
      <MdCheckCircle size={14} />
      <p>Regra ativa até o dia {parseExpirationDate(expirationDate)}</p>
    </span>
  );
};

export default ExpirationDateTag;
